import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PromotionItem,
  PromotionState
} from '@/modules/settings/promotions/types/types.ts'

const initialState: PromotionState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const promotionSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<PromotionItem | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const promotionsActions = promotionSlice.actions
export const { reducer: promotionsReducer } = promotionSlice
